import { Box, ListItem } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { inTransition } from "lib/@hooks/useRefresh"
import { HasMoved } from "event-definitions"

export function Moved({ task, from }) {
    HasMoved.useRefresh(inTransition)
    const index = task.$sort ? `${task.$sort + 1}. ` : ""
    return (
        <ListItem data-cy="moved-task">
            <ListItemBox>
                <Box flex={1}>
                    {index}
                    {task.title}
                </Box>
                <Box width={80}>{from}</Box>
            </ListItemBox>
        </ListItem>
    )
}
